import React from 'react'
import PropTypes from 'prop-types'

const PATH = 'M6.586 5.01267C7.36667 4.32933 8.63333 4.32933 9.414 5.01267C10.1953 5.696 10.1953 6.804 '
  + '9.414 7.48733C9.27867 7.60667 9.12733 7.70467 8.96733 7.782C8.47067 8.02267 8.00067 8.448 8.00067 '
  + '9V9.5M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 '
  + '12.2426C11.6855 12.7998 11.0241 13.2418 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 '
  + '6.43185 13.8448 5.7039 13.5433C4.97595 13.2418 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 '
  + '2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 '
  + '3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 '
  + '6.4087 14 8ZM8 11.5H8.00533V11.5053H8V11.5Z'

const CircleQuestionIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
      d={PATH}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
)

CircleQuestionIcon.propTypes = {
  className: PropTypes.string
}

CircleQuestionIcon.defaultProps = {
  className: 'tw:h-4 tw:w-4'
}

export default CircleQuestionIcon
